import { render, staticRenderFns } from "./Damage.vue?vue&type=template&id=8c74cce8&"
import script from "./Damage.vue?vue&type=script&lang=js&"
export * from "./Damage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports